import { hasClientPrivacy, hiddenClientFields } from "./client-privacy";

let sessionUser = null;
export const getPrivacySession = () => sessionUser;
export const setPrivacySession = (user) => { sessionUser = user || null; };
export const privacySignature = (user) => `${user?.id || ""}:${[...hiddenClientFields(user)].sort().join(",")}`;
export const clientOfflineAllowed = () => {
  const user = getPrivacySession();
  return !!user && user.user_type !== "client" && !hasClientPrivacy(user);
};
